
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Framework() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  const steps = [
    {
      number: '01',
      title: 'Audit & Infrastructure Mapping',
      description: 'We assess operational gaps, data flow, and system fragmentation.',
      icon: 'ri-search-eye-line'
    },
    {
      number: '02',
      title: 'AI System Design',
      description: 'We architect a structured automation framework aligned to revenue goals.',
      icon: 'ri-draft-line'
    },
    {
      number: '03',
      title: 'Implementation & Integration',
      description: 'Secure deployment into your CRM, communication, and reporting systems.',
      icon: 'ri-code-s-slash-line'
    },
    {
      number: '04',
      title: 'Optimization & Scale',
      description: 'Continuous refinement, data insights, and expansion planning.',
      icon: 'ri-rocket-2-line'
    }
  ];

  return (
    <section id="framework" className="py-28 md:py-40 bg-[#0A1A3F]">
      <div ref={ref} className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className={`text-center mb-24 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-6">
            Our Process
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-white leading-[1.1]">
            Deployment Architecture
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`group relative p-8 rounded-2xl bg-white/[0.04] border border-white/[0.08] hover:border-[#D4AF37]/30 hover:bg-white/[0.06] transition-all duration-500 cursor-default ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${200 + index * 120}ms` : '0ms' }}
            >
              <div className="flex items-start gap-5">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-xl bg-[#D4AF37]/10 group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                  <i className={`${step.icon} text-[#D4AF37] text-lg`}></i>
                </div>
                <div className="flex-1">
                  <span className="text-xs font-semibold tracking-[0.2em] text-[#D4AF37]/60 uppercase">
                    Step {step.number}
                  </span>
                  <h3 className="text-xl font-serif text-white mt-1.5 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm font-light text-white/50 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
